<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Υπογραφές</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>A/A</th>
                    <th>Υπογραφές</th>
                    <th>Ενέργειες</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(signature, index) in this.signatures"
                    :key="index"
                  >
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ signature.name }}</td>
                    <td v-if="is_staff">
                      <button
                        type="button"
                        class="btn btn-warning btn"
                        @click="$bvModal.show(signature.name)"
                        style="margin-right:20px"
                      >
                        <i class="mdi mdi-pencil"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn"
                        @click.prevent="confirm(signature.id)"
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </button>
                    </td>
                    <b-modal
                      :id="signature.name"
                      title="Επεξεργασία Υπογραφής"
                      centered
                      hide-footer
                    >
                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body">
                            <h4 class="card-title">Επεξεργασία Υπογραφής</h4>
                            <b-alert
                              v-if="is_success"
                              show
                              dismissible
                              :variant="alertVariant"
                              >{{ alertMsg }}</b-alert
                            >
                            <p class="card-title-desc">
                              Συμπληρώστε την παρακάτω φόρμα για επεξεργασία
                              Υπογραφής
                            </p>
                            <form
                              class="needs-validation"
                              @submit.prevent="parseUpdateSignature(signature)"
                            >
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="mb-3">
                                    <label for="validationCustom01"
                                      >Υπογραφή</label
                                    >
                                    <input
                                      id="validationCustom01"
                                      type="text"
                                      class="form-control"
                                      placeholder="Υπογραφή"
                                      required
                                      :value="signature.name"
                                      ref="signatureInput"
                                    />
                                  </div>
                                </div>
                              </div>

                              <button class="btn btn-primary" type="submit">
                                Ολοκλήρωση
                              </button>
                            </form>
                          </div>
                        </div>
                        <!-- end card -->
                      </div>
                    </b-modal>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="is_staff">
          <FormModal @SignatureFormModal="parseFormAddSignatureModal" />
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import session from "../../../api/session";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import FormModal from "./form-modal.vue";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import { eventCreate } from "../../../eventspy.js";
export default {
  page: {
    title: "Υπογραφές",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, FormModal },
  data() {
    return {
      title: "Υπογραφες",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Υπογραφές",
          active: true,
        },
      ],
      signatures: [],
      signatureName: "",
      is_success: false,
      alertVariant: "",
      alertMsg: "",
    };
  },
  mounted() {
    this.fetchSigantures();
  },
  computed: {
    newOptions() {
      return this.options.map((e) => e.name);
    },

    ...mapGetters("auth", ["userLoggedIn", "is_staff"]),
  },
  methods: {
    confirm(signatureId) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          this.deleteSignature(signatureId);
          Swal.fire("Διαγράφηκε!", "Η υπογραφή σας έχει διαγραφεί.", "success");
        }
      });
    },
    async parseFormAddSignatureModal(signatureName) {
      console.log(signatureName);
      await session
        .post("api/signature/create/", {
          name: signatureName,
        })
        .then(() => {
          {
            eventCreate(`Προσθήκη υπογραφής ${signatureName}`, 1);
            this.fetchSigantures();
            this.$store.dispatch("utils/getSignatures");
          }
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    async deleteSignature(signatureId) {
      const sig = this.signatures.find((e) => e.id === signatureId).name;
      eventCreate(`Διαγραφή υπογραφής ${sig}`, 3);
      await session
        .delete(`api/signature/${signatureId}/delete/`)
        .then(() => {
          this.fetchSigantures();
          this.$store.dispatch("utils/getSignatures");
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    async updateSignature(signatureId, signatureName) {
      await session
        .put(`api/signature/${signatureId}/update/`, {
          name: signatureName,
        })
        .then((resp) => {
          const oldSig = this.signatures.find((e) => e.id === signatureId).name;
          this.is_success = true;
          this.alertVariant = "success";
          this.alertMsg = "Ανανεώθηκε επιτυχώς";
          eventCreate(
            `Επεξεργασία υπογραφής ${oldSig} ------------------${JSON.stringify(
              resp.data
            )}`,
            2
          );
          this.$store.dispatch("utils/getSignatures");
          this.fetchSigantures();
        })
        .catch((e) => {
          console.log(e.response.data);
          this.alertVariant = "danger";
          this.alertMsg = "Σφάλμα κατά την ανανέωση υπογραφής";
        });

      setTimeout(() => {
        this.$bvModal.hide(signatureName);
        this.alertVariant = null;
        this.alertMsg = "";
      }, 3000);
    },
    parseUpdateSignature(signature) {
      const old_signature = signature.name;
      const new_signature = this.$refs["signatureInput"].map((e) => {
        return e.value;
      });

      if (new_signature.length > 0 && old_signature != new_signature[0]) {
        this.updateSignature(signature.id, new_signature[0]);
      } else {
        this.updateSignature(signature.id, old_signature);
      }
    },
    async fetchSigantures() {
      await session.get("api/signatures/").then((resp) => {
        this.signatures = resp.data;
      });
    },
  },
};
</script>
